// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2CJbT","subheader":"ReorderModal_subheader__3bwLG","listWrap":"ReorderModal_listWrap__1WExq"};